module.exports = __webpack_public_path__ + "static/media/cor.be4acf81.jpeg";